import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from './services/cache.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dmbr-ui-bo';

  constructor(private translationService: TranslateService ,
    private cacheService: CacheService){
      translationService.setDefaultLang('en');
    }
    ngOnInit() {
      this.translationService.addLangs(['en', 'fr']);
      this.translationService.setDefaultLang('en');
      this.cacheService.setItem('locale', 'en'); 
    }
}
